
import { Component, Vue } from 'vue-property-decorator'

import { OrderSteps, Views } from '@/enums';

@Component({
  components: {
  }
})
export default class Back extends Vue {
  back() {
    const steps = Object.values(OrderSteps);
    const currentStep: any = (steps?.find((step) => step.view === this.$route.name || step.aliasViews.includes(this.$route.name as never)) || {});
    const previousStep: any = (steps.find((step) => step.step === currentStep?.step - 1) || {});

    if ([Views.CHOOSE_FOOD_CATEGORY].includes(this.$route.name as never)) {
      return this.$router.push({
        name: Views.CHOOSE_FOOD,
        params: {
          ...this.$route.params,
        },
      });
    } else if ([Views.PRODUCT_ADD, Views.PRODUCT_EDIT].includes(this.$route.name as Views)) {
      return this.$router.push({
        name: Views.CHOOSE_FOOD_CATEGORY,
        params: {
          ...this.$route.params,
        },
      });
    } else if (Views.CHECKOUT === this.$route.name) {
      return this.$router.push({
        name: Views.ORDER_SUMMARY,
        params: {
          ...this.$route.params,
        },
      });
    } else {
      return this.$router.push({
        name: previousStep.view,
        params: {
          ...this.$route.params,
        },
      });
    }
  }
}
